import axios from 'axios'
import { useContext, useEffect, useState } from 'react'
import { constants } from '../Constants'
import { ModalCreateCommunication } from '../components/Modals/ModalCreateCommunication'
import { PageLoader } from '../components/ui/Spinner/Spinner'
import { useToast } from '../components/ui/Toast/Toast'
import { NotificationsContext } from '../context/NotificationsContext'
import '../styles/shared.scss'

export const Comunications = () => {
  const [communications, setCommunications] = useState([])
  const [loading, setLoading] = useState(true)
  const [expandedId, setExpandedId] = useState(null)
  const [editId, setEditId] = useState(null)
  const [editForm, setEditForm] = useState({
    title: '',
    content: '',
    visible: true,
  })
  const { getNotifications } = useContext(NotificationsContext)
  const toast = useToast()
  const user = JSON.parse(localStorage.getItem('user'))

  const fetchCommunications = async () => {
    setLoading(true)
    try {
      const res = await axios.get(
        `${constants.urlLocal}communications/getAllCommunications`
      )
      setCommunications(res.data.communications || [])
    } catch (error) {
      console.error(error)
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchCommunications()
  }, [])

  const deleteCommunication = async id => {
    try {
      await axios.delete(
        `${constants.urlLocal}communications/deleteCommunication/${id}`
      )
      toast({ title: 'Comunicación eliminada', status: 'success' })
      fetchCommunications()
      getNotifications()
    } catch (error) {
      toast({ title: 'Error al eliminar', status: 'error' })
    }
  }

  const toggleVisibility = async com => {
    try {
      await axios.put(
        `${constants.urlLocal}communications/updateCommunication/${com._id}`,
        {
          ...com,
          visible: !com.visible,
        }
      )
      toast({ title: com.visible ? 'Oculta' : 'Visible', status: 'info' })
      fetchCommunications()
    } catch (error) {
      toast({ title: 'Error al actualizar', status: 'error' })
    }
  }

  const startEditing = com => {
    setEditId(com._id)
    setEditForm({
      title: com.title,
      content: com.content,
      visible: com.visible,
    })
  }

  const saveEdit = async () => {
    try {
      await axios.put(
        `${constants.urlLocal}communications/updateCommunication/${editId}`,
        editForm
      )
      toast({ title: 'Comunicación actualizada', status: 'success' })
      setEditId(null)
      fetchCommunications()
    } catch (error) {
      toast({ title: 'Error al actualizar', status: 'error' })
    }
  }

  const formatDate = d =>
    new Date(d).toLocaleDateString('es-ES', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    })

  if (loading)
    return (
      <div className="loading-center">
        <PageLoader />
      </div>
    )

  return (
    <div className="page-container">
      <div className="flex-between" style={{ marginBottom: '1.5rem' }}>
        <h2 className="page-title" style={{ marginBottom: 0 }}>
          Comunicaciones
        </h2>
        {user?.role === 'admin' && (
          <ModalCreateCommunication loadCommunications={fetchCommunications} />
        )}
      </div>

      {communications.length === 0 ? (
        <p className="empty-state">No hay comunicaciones</p>
      ) : (
        <div
          style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}
        >
          {communications.map(com => (
            <div
              key={com._id}
              className="card-box"
              style={{ opacity: com.visible ? 1 : 0.5 }}
            >
              {editId === com._id ? (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem',
                  }}
                >
                  <input
                    className="form-input"
                    value={editForm.title}
                    onChange={e =>
                      setEditForm({ ...editForm, title: e.target.value })
                    }
                  />
                  <textarea
                    className="form-textarea"
                    rows={3}
                    value={editForm.content}
                    onChange={e =>
                      setEditForm({ ...editForm, content: e.target.value })
                    }
                  />
                  <label className="form-checkbox">
                    <input
                      type="checkbox"
                      checked={editForm.visible}
                      onChange={e =>
                        setEditForm({
                          ...editForm,
                          visible: e.target.checked,
                        })
                      }
                    />{' '}
                    Visible
                  </label>
                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <button
                      className="btn btn--primary btn--sm"
                      onClick={saveEdit}
                    >
                      Guardar
                    </button>
                    <button
                      className="btn btn--secondary btn--sm"
                      onClick={() => setEditId(null)}
                    >
                      Cancelar
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  <div
                    className="flex-between"
                    onClick={() =>
                      setExpandedId(expandedId === com._id ? null : com._id)
                    }
                    style={{ cursor: 'pointer' }}
                  >
                    <div>
                      <h4 style={{ fontWeight: 700 }}>{com.title}</h4>
                      <span style={{ fontSize: '0.75rem', color: '#999' }}>
                        {formatDate(com.createdAt)}
                      </span>
                    </div>
                    <span
                      style={{
                        fontSize: '1.2rem',
                        transform:
                          expandedId === com._id ? 'rotate(180deg)' : 'none',
                        transition: 'transform 0.2s',
                      }}
                    >
                      ▼
                    </span>
                  </div>
                  {expandedId === com._id && (
                    <div
                      style={{
                        marginTop: '0.75rem',
                        paddingTop: '0.75rem',
                        borderTop: '1px solid #eee',
                      }}
                    >
                      <div
                        style={{
                          color: '#555',
                          marginBottom: '0.75rem',
                        }}
                        dangerouslySetInnerHTML={{ __html: com.content }}
                      />
                      {user?.role === 'admin' && (
                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                          <button
                            className="btn btn--secondary btn--sm"
                            onClick={() => startEditing(com)}
                          >
                            ✏️ Editar
                          </button>
                          <button
                            className="btn btn--secondary btn--sm"
                            onClick={() => toggleVisibility(com)}
                          >
                            {com.visible ? '👁️ Ocultar' : '👁️‍🗨️ Mostrar'}
                          </button>
                          <button
                            className="btn btn--danger btn--sm"
                            onClick={() => deleteCommunication(com._id)}
                          >
                            🗑️ Eliminar
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
